module.exports = __webpack_public_path__ + "img/temp1.ec6b021e.svg";